module.exports = __webpack_public_path__ + "media/images/pic/sample3-ea825ff387f7af6c8fb42fd0da0fc671.webp";